import styled, { css } from 'styled-components';
import { maxWidth, minWidth } from '@/assets/styles/mixins.css';
import vars from '@/assets/styles/vars';
import Button from '@/components/styles/StyledButton';

const Directions = styled.div`
  padding-bottom: 50px;

  ${maxWidth(vars.breakpoints.tablet)`
    padding-bottom:30px;
  `}

  ${(props) =>
    props.size == 'mid' &&
    css`
      padding-bottom:35px;
    `}

  ${(props) =>
    props.center &&
    css`
    .swiper-wrapper {
      justify-content:center;

      ${maxWidth(vars.breakpoints.tablet)`
        justify-content:unset;
      `}
    }
    `}
`;

Directions.Content = styled.div`
  .swiper-container {
    overflow: visible;
  }

  .swiper-scrollbar {
    display: none;
  }

  ${maxWidth(vars.breakpoints.tablet)`
    .swiper-scrollbar {
      display: block;
      position: relative;
      width: 100%;
      height: 20px;
      margin-top: 8px;
      background: transparent;
      cursor: pointer;
      touch-action: none;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        height: 3px;
        border-radius: 3px;
        background: rgba(var(--color-decor-rgb), 0.25);
        transform: translateY(-50%);
        pointer-events: none;
      }
    }

    .swiper-scrollbar-drag {
      position: absolute;
      top: 50%;
      height: 3px;
      margin-top: -1.5px;
      border-radius: 3px;
      background: var(--color-decor);
      cursor: pointer;
    }

    .swiper-scrollbar-lock {
      display: none;
    }
  `}

  .swiper-wrapper {
    row-gap: 10px;
    flex-wrap: wrap;

    ${maxWidth(vars.breakpoints.tablet)`
    flex-wrap: nowrap;
    `}

    ${minWidth(vars.breakpoints.tablet + 1)`
    transform: none !important;
    height: 100% !important;
    `}
  }
`;

Directions.Item = styled.div`
  display: flex;
  width: fit-content;
  margin-right: 10px;

  ${Button} {
    &:focus,
    &:active {
      background: var(--color-decor);
      color:#fff;
    }
  }
`;

export default Directions;
